<template>
  <select class="form-select" :value="value" @change="doChange($event)">
    <option />
    <option v-for="option in $constant.PREFECTURE.LIST" :key="option.code" :value="option.code">
      {{ option.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: "PrefectureSelect",
  props: {
    label: {
      type: String,
      required: false,
      default: '都道府県'
    },
    value: {
      type: [Number, null],
      required: true,
    },
    setHandler: {
      type: Function,
      default: () => {
      }
    },
  },
  inject: [
    '$constant'
  ],
  methods: {
    doChange(event) {
      this.setHandler({value: event.target.value});
    }
  }
}
</script>
